/**
 * @export CustomEmailType constructor
 * @param  {} data={}
 */

export default function CustomEmailType(data = {}) {
  this.type = data.type;
  this.subject = data.subject || '';
  this.title = data.title || '';
  this.header = data.header || '';
  this.body = data.body || '';
  this.button = data.button || '';
  this.nextStepContactInfo = data.nextStepContactInfo || '';

  return this;
}
